import instanceAxios from '@/util/axios';
import { GetStaffMemberRequest, GetStaffMemberResponse } from './getStaffMember.types';
import { getStaffMemberByIdUrl } from '@/constants';

export async function getStaffMember(params?: GetStaffMemberRequest): Promise<GetStaffMemberResponse> {
  const response = await instanceAxios.get<GetStaffMemberResponse>(getStaffMemberByIdUrl, { params });
  return response.data;
}
